import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';
import {emitEventLog} from '@di-shared/features/analytics';

function ElectricDeviceDetectionTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={3}
      onOpen={() =>
        emitEventLog({
          event: 'vehicle_status_check',
          interaction_type: 'tooltip click',
          click_text: t('T30109'),
          click_location: 'body',
        })
      }
      tooltip={
        <div
          role="tooltip"
          id="tooltipBox02"
        >
          <strong className="tooltip_title">{t('T30109')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30110')}</li>
          </ul>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox02"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          />
        </button>
      </div>
    </Popper>
  );
}

export default ElectricDeviceDetectionTooltip;
